var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4922_6425)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.75781C6.56345 2.75781 2.15625 7.16501 2.15625 12.6016C2.15625 18.0381 6.56345 22.4453 12 22.4453C17.4366 22.4453 21.8438 18.0381 21.8438 12.6016C21.8438 7.16501 17.4366 2.75781 12 2.75781ZM18.5625 12.6016C18.5625 16.2259 15.6244 19.1641 12 19.1641C8.37562 19.1641 5.4375 16.2259 5.4375 12.6016C5.4375 8.97718 8.37562 6.03906 12 6.03906C15.6244 6.03906 18.5625 8.97718 18.5625 12.6016ZM13.0938 8.66406C13.0938 8.06001 12.6041 7.57031 12 7.57031C11.3959 7.57031 10.9062 8.06001 10.9062 8.66406V12.6016C10.9062 12.8916 11.0215 13.1698 11.2266 13.375L13.8516 16C14.2787 16.4271 14.9713 16.4271 15.3984 16C15.8255 15.5728 15.8255 14.8803 15.3984 14.4531L13.0938 12.1485V8.66406Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4922_6425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(1.5 2.10156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.85f2960a563d977587db86b7517055b6.svg";
export { ForwardRef as ReactComponent };